import React from 'react';

function Question(props) {
  const { question } = props;

  const renderQuestionOptions = (questionOptions) => (
    <div>
      {questionOptions.map((qo, index) => {
        let option = qo.option;
        const typeOf = typeof qo.option;
        if (typeOf === 'boolean'){
          option = qo.option ? 'True' : 'False';
        }
        return (
          <div key={index}>
            <span className={qo.isAnswer ? 'green-text' : 'red-text'}>- {option}</span>
          </div>
        );
      })}
    </div>
  );

  return (
    <div className="card">
      <div className="card-content">
        <span>Question: {question.question}</span>
        <br />
        <span>Type: {question.type}</span>
        <div>
          Options:
          <br />
          {renderQuestionOptions(question.questionOptions)}
        </div>
      </div>
    </div>
  );
}

export default Question;
